import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Form, Input, Modal, Progress, Spin, Transfer } from "antd";
import { axiosErrorHandler } from "../../../swzutils";
import HelpLabel from "./HelpLabel";
const DriverMessageModal = (props) => {
    const formRef = React.useRef(null);
    const [stateLoadingDrivers, setStateLoadingDrivers] = useState(false);
    const [stateSendingMessages, setStateSendingMessages] = useState(false);
    const [stateCancelSending, setStateCancelSending] = useState(false);
    const [statePercentComplete, setStatePercentComplete] = useState(0);
    const [stateDrivers, setStateDrivers] = useState([]);
    const [stateInProgressDriver, setStateInProgressDriver] = useState(null);
    const [stateSelectedKeys, setStateSelectedKeys] = useState([]);
    useEffect(() => {
        if (props.open) {
            loadActiveDrivers();
        }
        else {
            formRef.current?.resetFields();
        }
    }, [props.open]);
    const loadActiveDrivers = () => {
        setStateLoadingDrivers(false);
        axios.get(`/admin/v1/user-sessions/active?userType=DRIVER&limit=999`)
            .then(response => {
            const sessions = response.data.results;
            const drivers = sessions.map(session => {
                let name = session.user.firstName + " " + session.user.lastName;
                return {
                    key: session.user.id,
                    title: name,
                    description: name
                };
            });
            if (props.selectedDriverUserIds && props.selectedDriverUserIds.length) {
                // Validate passed in drivers are logged in.  The Transfer component does not validate
                // selections so if we don't do this you end up with "invisible" selections
                const loggedInDriverUsesrIds = props.selectedDriverUserIds.filter(id => {
                    return !!drivers.find(driver => driver.key === id);
                });
                formRef.current?.setFieldsValue({
                    driverIds: loggedInDriverUsesrIds
                });
            }
            setStateDrivers(drivers);
        })
            .catch(axiosErrorHandler)
            .finally(() => {
            setStateLoadingDrivers(false);
        });
    };
    const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
        setStateSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    };
    const onFinish = (formValues) => {
        setStateSendingMessages(true);
        setStateCancelSending(false);
        const workQueue = formValues.driverIds.map((driverId) => ({
            driverId: driverId,
            title: formValues.title,
            message: formValues.message
        }));
        // TODO: Improve error management here.  If a message or network request fails
        //       it is silently ignored and not shown to the user.
        let workQueueIndex = 0;
        const dequeueWorkItem = () => {
            if (!stateCancelSending && workQueueIndex < workQueue.length) {
                const percentComplete = Math.round((workQueueIndex / workQueue.length) * 100);
                const workItem = workQueue[workQueueIndex++];
                const inProgressDriver = stateDrivers.find(driver => driver.key === workItem.driverId);
                setStateInProgressDriver(inProgressDriver ?? null);
                setStatePercentComplete(percentComplete);
                return workItem;
            }
            else {
                return null;
            }
        };
        const sendMessage = (workItem) => {
            const request = {
                title: workItem.title,
                message: workItem.message
            };
            /*
             * Uncomment this to emulate sending messages for UI manual testing.
            setTimeout(() => {
                const item = dequeueWorkItem();
                if (item) {
                    sendMessage(item)
                } else {
                    this.setState({
                        sendingMessages: false
                    });
                    this.props.onOk();
                }
            }, 3000);
            return;
            */
            axios.post(`/admin/v1/communications/driver/${workItem.driverId}`, request)
                .finally(() => {
                const item = dequeueWorkItem();
                if (item) {
                    sendMessage(item);
                }
                else {
                    setStateSendingMessages(false);
                    props.onOk();
                }
            });
        };
        const nextWorkItem = dequeueWorkItem();
        if (nextWorkItem) {
            sendMessage(nextWorkItem);
        }
    };
    const onCancel = () => {
        if (stateSendingMessages) {
            setStateSendingMessages(true);
            setStateCancelSending(true);
        }
        else {
            props.onCancel();
        }
    };
    let inProgressDriverName = stateInProgressDriver && stateInProgressDriver.title;
    if (stateCancelSending) {
        inProgressDriverName += " (Cancelling)";
    }
    return (_jsx(Modal, { title: "Message Driver", open: props.open, confirmLoading: stateSendingMessages, onOk: () => formRef.current?.submit(), onCancel: onCancel, destroyOnHidden: true, width: 660, children: _jsxs(Spin, { spinning: stateLoadingDrivers, children: [_jsxs(Form, { layout: "vertical", ref: formRef, onFinish: onFinish, children: [_jsx(Form.Item, { name: "driverIds", valuePropName: "targetKeys", initialValue: props.selectedKeys, label: _jsx(HelpLabel, { title: "Drivers", helpText: "Driver messaging is available for company drivers only" }), rules: [{
                                    required: true,
                                    message: 'Please select a driver',
                                }], children: _jsx(Transfer, { dataSource: stateDrivers, titles: ['Logged in Drivers', 'Selected Drivers'], selectedKeys: stateSelectedKeys, onSelectChange: handleSelectChange, showSearch: true, listStyle: {
                                    width: 280,
                                    height: 300,
                                }, disabled: stateSendingMessages, render: item => item.title }) }), _jsx(Form.Item, { name: "title", label: "Title", rules: [{
                                    required: true,
                                    message: 'Please enter a title',
                                }], children: _jsx(Input, { disabled: stateSendingMessages }) }), _jsx(Form.Item, { name: "message", label: "Message", rules: [{
                                    required: true,
                                    message: 'Please enter a message',
                                }], children: _jsx(Input.TextArea, { disabled: stateSendingMessages, autoSize: {
                                    minRows: 4
                                } }) })] }), stateSendingMessages &&
                    _jsxs("div", { children: [_jsxs("h4", { className: "text-center", children: ["Sending to ", inProgressDriverName] }), _jsx(Progress, { percent: statePercentComplete })] })] }) }));
};
export default DriverMessageModal;
